import React, { useState, useEffect, useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import { hideSegundoModal } from "../../../context/Actions/segundoModal/segundoModal";
import "./SegundoModal.css";

const SegundoModal = () => {
  const { segundoModalState, segundoModalDispatch } = useContext(PortalContext);
  const [animation, setAnimation] = useState("");
  const [component, setComponent] = useState("");
  const [params, setParams] = useState("");
  const [listBotones, setListBotones] = useState([]);
  const [posicion, setPosicion] = useState(["centro2"]);
  const [bloquearDissmiss, setBloquearDissmiss] = useState(true);

  const dissmiss = () => {
    if (!bloquearDissmiss) {
      setAnimation("");
      hideSegundoModal()(segundoModalDispatch);
    }
  };

  const preventDissmiss = (event) => {
    event.stopPropagation();
  };
  useEffect(() => {
    if (
      segundoModalState.segundoModal.data !== undefined &&
      segundoModalState.segundoModal.data.template !== null &&
      segundoModalState.segundoModal.data.template !== undefined &&
      segundoModalState.segundoModal.data.template !== ""
    ) {
      if (
        segundoModalState.segundoModal.data.posicion !== undefined &&
        segundoModalState.segundoModal.data.posicion !== null &&
        segundoModalState.segundoModal.data.posicion !== ""
      ) {
        setPosicion(segundoModalState.segundoModal.data.posicion);
        switch (segundoModalState.segundoModal.data.posicion) {
          case "centro2":
            setAnimation("desplazarCentro2");
            break;
          case "centroAbajo2":
            setAnimation("desplazarCentroAbajo2");
            break;
          case "centroDerecha2":
            setAnimation("desplazarCentroDerecha2");
            break;
          default:
            setAnimation("desplazarCentro2");
        }
      }
      setComponent(segundoModalState.segundoModal.data.template);
      setBloquearDissmiss(segundoModalState.segundoModal.data.bloquearDissmiss);
      setParams(segundoModalState.segundoModal.data.params);
      if (Array.isArray(segundoModalState.segundoModal.data.listBotones)) {
        setListBotones(segundoModalState.segundoModal.data.listBotones);
      } else {
        setListBotones([]);
      }
    }
  }, []);

  return (
    <React.Fragment>
      <div className="ptur-modalSegundo-fondo" onClick={dissmiss}>
        <div
          className={`modalContent2 ${animation} ${posicion}`}
          onClick={preventDissmiss}
        >
          {component !== "" &&
            component !== null &&
            component !== undefined &&
            React.createElement(require("../../" + component).default, params)}
          {Array.isArray(listBotones) && listBotones.length > 0 && (
            <div className="footerModal2">
              {listBotones.map((item, i) => {
                return (
                  <button className={item.clase} onClick={item.accion} key={i}>
                    {item.text}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};
export default SegundoModal;
